export const formInputData = [
	{ name: "firstName", label: "First name", required: true },
	{ name: "lastName", label: "Last name", required: true },
	{ name: "address1", label: "Address", required: true },
	{ name: "email", label: "Email", required: true },
	{ name: "city", label: "City", required: true },
	{ name: "zip", label: "Zip / Postal Code", required: true },
];

export const links = [
	{
		id: 1,
		text: "home",
		url: "/",
	},
	{
		id: 2,
		text: "about",
		url: "/about",
	},
	{
		id: 3,
		text: "shop",
		url: "/shop",
	},
	{
		id: 4,
		text: "sign in",
		url: "/signin",
	},
];

